"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    SuggestionChip: ()=>SuggestionChip
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_SuggestionChip_variants_cjs_namespaceObject = require("./SuggestionChip.variants.cjs");
function SuggestionChip({ label, className, disabled, onClick, emoji, iconLeft, elevated = false, count, ...props }) {
    const handleClick = ()=>{
        onClick?.();
    };
    const { labelTextSlot, containerSlot, iconLeftSlot, countSlot } = (0, external_SuggestionChip_variants_cjs_namespaceObject.suggestionChipVariants)({
        ...props,
        disabled: disabled,
        elevated: elevated,
        hasCount: void 0 !== count
    });
    const classes = (0, index_cjs_namespaceObject.cn)(containerSlot(), className);
    const iconSize = 'tile' === props.type ? '20' : '18';
    const renderIconOrEmoji = ()=>{
        if (iconLeft) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
            className: iconLeftSlot(),
            iconName: iconLeft,
            size: iconSize
        });
        if (emoji) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
            className: iconLeftSlot(),
            role: "img",
            children: emoji
        });
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("button", {
        className: classes,
        onClick: handleClick,
        disabled: disabled,
        ...(0, index_cjs_namespaceObject.cleanProps)(props, [
            'type',
            'elevated',
            'emphasis'
        ]),
        children: [
            renderIconOrEmoji(),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                className: labelTextSlot(),
                children: label
            }),
            void 0 !== count && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("span", {
                className: countSlot(),
                children: [
                    "(",
                    count,
                    ")"
                ]
            })
        ]
    });
}
exports.SuggestionChip = __webpack_exports__.SuggestionChip;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "SuggestionChip"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
